import type {
  AdditionalProperties,
  TrackingData,
  CoreMetadataProperties,
} from './trackingTypes'

import { Product, Client } from '@buffer-mono/tracking-plan'

import type {
  CommonTrackingProperties,
  AccountData as Account,
} from '~publish/contexts/AccountContext'

export const getCoreTrackingMetadata = (
  account: Account | null,
): CoreMetadataProperties => {
  const organizationId = account?.currentOrganization?.id ?? null
  return {
    organizationId,
    product: Product.Publish,
    clientName: Client.PublishWeb,
  }
}

export const createEventTrackingData = (
  metadata: CoreMetadataProperties,
  commonProps: CommonTrackingProperties | null,
  additionalProps: AdditionalProperties,
): TrackingData => ({
  ...metadata,
  ...commonProps,
  ...additionalProps,
})
